import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryNavigation = ({ categories, selectedCategory, onCategorySelect }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <h3 className="text-lg font-semibold text-foreground mb-4">Categories</h3>
      <div className="space-y-2">
        {categories?.map((category) => (
          <button
            key={category?.id}
            onClick={() => onCategorySelect(category?.id)}
            className={`w-full flex items-center justify-between p-3 rounded-lg transition-all ${
              selectedCategory === category?.id
                ? 'bg-primary/10 border border-primary/20' :'bg-muted/50 hover:bg-muted border border-transparent'
            }`}
          >
            <div className="flex items-center gap-3">
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                selectedCategory === category?.id ? 'bg-primary/20' : 'bg-background'
              }`}>
                <Icon
                  name={category?.icon}
                  size={18}
                  className={selectedCategory === category?.id ? 'text-primary' : 'text-muted-foreground'}
                />
              </div>
              <span className={`text-sm font-medium ${
                selectedCategory === category?.id ? 'text-primary' : 'text-foreground'
              }`}>
                {category?.name}
              </span>
            </div>
            <span className={`text-xs font-semibold px-2 py-1 rounded-full ${
              selectedCategory === category?.id
                ? 'bg-primary/20 text-primary' :'bg-background text-muted-foreground'
            }`}>
              {category?.count}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryNavigation;